<template>
    <div class="play-list">
        <ul class="song-list">
            <li
                v-for="(audio) in audioList" 
                :key="audio.id" 
                class="song-item" 
                @click="handlePlay(audio)">
                <div class="song-item-content">
                    <span
                        v-for="(part, index) in audio.parsedCut"
                        :key="index"
                        :style="{ color: part.color }"
                    >{{ part.text }}</span>
                </div>
                <img
                    v-show="!audio.playing"
                    src="../images/list-play.png"
                    class="song-item-icon"
                >
                <img
                    v-show="audio.playing"
                    src="../images/list-pause.png"
                    class="song-item-icon"
                >
            </li>
        </ul>
    </div>
</template>

<script>
import dayjs from 'dayjs'

export default {
    name: 'PlayerList',
    props: {
        audioList: {
            type: Array,
            default: () => [],
        }
    },
    data() {
        return {
            dayjs,
            currentSong: {},
        }
    },
    watch: {
        audioList: {
            handler(newVal) {
                newVal.forEach(audio => {
                    audio.parsedCut = this.parseCut(audio.cut);
                });
            },
            immediate: true,
        }
    },
    methods: {
        toggleList(week) {
            week.isExpanded = !week.isExpanded
        },
        handlePlay(audio) {
            audio.playing = !audio.playing
            
            this.$emit('play', audio)
        },
        parseCut(cut) {
            const parts = cut.split('/');
            return parts.map(part => {
                const color = part.startsWith('红') ? 'red' : part.startsWith('蓝') ? 'blue' : 'black';
                return { color, text: part.length === 1 ? ' ' : part.slice(1) };
            });
        }
    },
}
</script>

<style lang="stylus" scoped>
.play-list {
    box-sizing: border-box;
    width: 620px;
    height: 87vh;
    padding: 100px 0;
    background: url('../images/list-bg.png') center/100% 100% no-repeat;
}

.song-list {
    width: 440px;
    height: 100%;
    padding: 0;
    margin: 8px auto;
    list-style: none;
    overflow: auto;
}
.song-item {
    display: flex;
    justify-content: space-between;
    align-items: center;
    height: 88px;
    padding: 0 28px;
    margin-bottom: 12px;
    background-color: #EDFCFD;
    border-radius: 88px;
    border: 1px solid #C1D1E7;
    color: #000;
    font-weight: 600;
}
.song-item-content {
    font-size: 40px;
    font-variant-ligatures: none;
    font-feature-settings: 'liga' 0;
}
.song-item-icon {
    width: 48px;
    height: 48px;
}

/* 动画基础样式 */
.slide-enter-active, .slide-leave-active {
    transition: all 0.3s ease;
}
.slide-enter, .slide-leave-to {
    opacity: 0;
}
</style>